var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseBold(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.132 32.285l21.619-21.619C64 8.417 64 4.782 61.751 2.534s-5.884-2.249-8.132 0L32 24.147 10.381 2.528C8.132.279 4.497.279 2.249 2.528S0 8.412 2.249 10.66l21.619 21.619L2.249 53.904a5.744 5.744 0 000 8.132c1.122 1.121 2.594 1.685 4.066 1.685s2.945-.564 4.066-1.685L32 40.417l21.619 21.619c1.121 1.121 2.594 1.685 4.066 1.685s2.945-.564 4.066-1.685a5.744 5.744 0 000-8.132L40.132 32.285z"
  })));
}
export default SvgCloseBold;